"use strict";
import AOS from "aos";
import main from "../css/sass/main.scss";
import inline from "../css/sass/inline.scss";
import mobileMenu from "./scripts/menu/mobileMenu";
import headerScrolling from "./scripts/headerScrolling";
import solutionsBullets from "./scripts/solutionsBullets";
import solutionsCircle from "./scripts/solutionsCircle";
import accordion from "./scripts/accordion";
import testimonialsSlider from "./scripts/testimonialsSlider";
import benefitsSlider from "./scripts/benefitsSlider";
import solutionsSlider from "./scripts/solutionsSlider";
import gallerySlider from "./scripts/gallerySlider";
import nossaHistoriaSlider from "./scripts/nossaHistoriaSlider";
import valoresSlider from "./scripts/valoresSlider";
import seguroSlider from "./scripts/seguroSlider";
import vantagensSlider from "./scripts/vantagensSlider";
import vantagensCategoria from "./scripts/vantagensCategoria";

AOS.init({
    once: true,
});

mobileMenu();
headerScrolling();
solutionsBullets();
solutionsCircle();
accordion();
testimonialsSlider();
benefitsSlider();
solutionsSlider();
gallerySlider();
nossaHistoriaSlider();
valoresSlider();
seguroSlider();
vantagensSlider();
vantagensCategoria();
